'use client';

import type { Currency } from '../../constants';
import { useSiteconfigService } from './useSiteconfigService';

export const useGetShippingPolicyByCurrency = (currency: Currency) => {
  const { useGetShippingPolicyByCurrency: useGetPolicy } = useSiteconfigService();
  const { data: shippingPolicy, ...rest } = useGetPolicy({ currency });

  return { shippingPolicy, ...rest };
};

